module.exports = __webpack_public_path__ + "assets/img/37_1026.68664187.jpg";